const mutations = {
  SET_REPORTS (state, { reports }) {
    state.reports = reports
  }
}

export default mutations
